import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { fruits } from '../data/fruits';
import './FruitDetailPage.css';

const FruitDetailPage = () => {
  const { fruitId } = useParams();
  const fruit = fruits.find(f => f.id === fruitId);

  if (!fruit) {
    return (
      <div className="fruit-not-found">
        <h2>抱歉，没有找到该水果的信息。</h2>
        <Link to="/">返回首页</Link>
      </div>
    );
  }

  const imageUrl = require(`../assets/svg/${fruit.image}`);

  return (
    <div className="fruit-detail-page">
      <div className="fruit-detail-header">
        <img src={imageUrl} alt={fruit.name} className="fruit-detail-image" />
        <div className="fruit-detail-title">
          <h1>{fruit.name}</h1>
          <p className="fruit-alias">别名: {fruit.alias}</p>
          <p className="fruit-meta">产地: {fruit.origin} | 季节: {fruit.season}</p>
        </div>
      </div>

      <div className="fruit-detail-content">
        <section className="fruit-benefits">
          <h2>对身体的益处</h2>
          <ul>
            {fruit.benefits.map((benefit, index) => (
              <li key={index}>
                <strong>{benefit.category}:</strong> {benefit.description}
              </li>
            ))}
          </ul>
        </section>

        <section className="fruit-nutrition">
          <h2>营养成分 (每100克)</h2>
          <table>
            <tbody>
              {Object.entries(fruit.nutrition).map(([key, value]) => (
                <tr key={key}>
                  <td>{key}</td>
                  <td>{value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        <section className="fruit-suitability">
          <h2>适用人群与禁忌</h2>
          <p><strong>适合:</strong> {fruit.suitability.suitable}</p>
          <p><strong>不适合:</strong> {fruit.suitability.unsuitable}</p>
        </section>

        <section className="fruit-tips">
          <h2>小贴士</h2>
          <p>{fruit.tips}</p>
        </section>
      </div>
    </div>
  );
};

export default FruitDetailPage;
